export const clientIDGoogle =
  "1030193571030-v3e8dt96668gstc7fcs8u3h9p3389jin.apps.googleusercontent.com";
export const clientIDFacebook = "197191957511161";
